/**
 * Feature flag constants shared across all apps.
 * These must match the flags created in the PostHog dashboard.
 *
 * Usage:
 * ```typescript
 * import { FeatureFlag } from '@pantry/shared';
 * const flag = FeatureFlag.SHOPPING_LISTS_PREMIUM;
 * ```
 */
export const FeatureFlag = {
  /** Premium: Shopping lists — 2nd+ lists, pinning, batch actions */
  SHOPPING_LISTS_PREMIUM: 'shopping-lists-premium',
} as const;

export type FeatureFlagValue = (typeof FeatureFlag)[keyof typeof FeatureFlag];
